<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset">
        <template slot="tableSearch">

          <el-form-item v-if="ROLE_TYPE.isManager()"
                        :label="$t('text.agent')">
            <el-select v-model="form.agentId"
                       filterable
                       clearable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option v-for="item in agentList"
                         :key="item.agentId"
                         :label="item.agentId + '-' + item.agentName"
                         :value="item.agentId"/>
            </el-select>
          </el-form-item>

          <el-form-item v-if="ROLE_TYPE.isManager() || ROLE_TYPE.isAgent()"
                        :label="$t('text.merchantName')">
            <el-select v-model="form.appId"
                       filterable
                       clearable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="merchant in merchantList"
                         :label="merchant.value + '-' + merchant.name"
                         :key="merchant.value"
                         :value="merchant.value"/>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.date')">
            <el-date-picker v-model="timeDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyyMMdd"
                            :range-separator="$t('text.to')"
                            :start-placeholder="$t('text.startDate')"
                            :end-placeholder="$t('text.endDate')"
                            @change="timeChange">
            </el-date-picker>
          </el-form-item>
        </template>
        <template slot="buttonArea">
          <el-button :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportDetail"
                     size="small">
            {{ $t('text.export') }}
          </el-button>
        </template>
        <template slot="tableColumn">
          <el-table-column width="100"
                           prop="statisticsDate"
                           :label="$t('text.date')"
                           :formatter="$formatter.formatDate"
                           align="center"/>
          <el-table-column width="180"
                           prop="updateTime"
                           :label="$t('text.updateTime')"
                           align="center"/>
          <el-table-column prop="agentId"
                           width="170px"
                           :label="$t('text.agentId')"
                           align="center"/>
          <el-table-column prop="agentName"
                           width="100px"
                           :label="$t('text.agentName')"
                           align="center"/>
          <el-table-column width="100px"
                           prop="appId"
                           :label="$t('text.appId')"
                           align="center"/>
          <el-table-column width="120px"
                           prop="merchantName"
                           :label="$t('text.merchantName')"
                           align="center"/>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <!-- Payment Rate Columns -->
          <el-table-column
              v-for="(value, key) in PaymentType[this.country].PAYMENT"
              width="120px"
              prop="paymentRateConfig"
              :label="$t(`text.collection${key}FeeRate`)"
              align="center"
          >
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.paymentRateConfig || '{}')[value] || '' }}
            </template>
          </el-table-column>
          <el-table-column
              v-for="(value, key) in PaymentType[this.country].PAYMENT"
              width="150px"
              prop="agentRateConfig"
              :label="$t(`text.collectionAgent${key}FeeRate`)"
              align="center"
          >
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.agentRateConfig || '{}')[value] || '' }}
            </template>
          </el-table-column>
          <el-table-column
              v-for="(value, key) in PaymentType[this.country].PAYMENT"
              width="110px"
              prop="rateConfigDifference"
              :label="$t(`text.${key}RateDifference`)"
              align="center"
          >
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.rateConfigDifference || '{}')[value] || '' }}
            </template>
          </el-table-column>

          <el-table-column width="130px"
                           prop="paymentAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.collectionAmount')"
                           align="center"/>
          <el-table-column width="110px"
                           prop="paymentAgentFee"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.agentCollectionProfit')"
                           align="center"/>

          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <!-- Transfer Rate Columns -->
          <el-table-column
              v-for="(value, key) in PaymentType[this.country].TRANSFER"
              width="120px"
              prop="transferRateConfig"
              :label="$t(`text.disbursement${key}FeeRate`)"
              align="center"
          >
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.transferRateConfig || '{}')[value] || '' }}
            </template>
          </el-table-column>
          <el-table-column
              v-for="(value, key) in PaymentType[this.country].TRANSFER"
              width="130px"
              :prop="`agentFeeConfig`"
              :label="$t(`text.agent${key}DisbursementProfit`)"
              align="center"
          >
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.agentFeeConfig || '{}')[value] || '' }}
            </template>
          </el-table-column>
          <el-table-column
              v-for="(value, key) in PaymentType[this.country].TRANSFER"
              width="110px"
              prop="feeConfigDifference"
              :label="$t(`text.${key}RateDifference`)"
              align="center"
          >
            <template slot-scope="scope">
              {{ JSON.parse(scope.row.feeConfigDifference || '{}')[value] || '' }}
            </template>
          </el-table-column>

          <el-table-column width="130px"
                           prop="transferAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.disbursementAmount')"
                           align="center"/>
          <el-table-column width="110px"
                           prop="transferAgentFee"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.agentDisbursementProfit')"
                           align="center"/>
          <el-table-column prop="" width="30px" label="|" align="center">|</el-table-column>

          <el-table-column width="150px"
                           prop="totalTransactionAmount"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.payAmountTotal')"
                           align="center"/>
          <el-table-column width="150px"
                           prop="totalAgentFee"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.agentPayAmountTotal')"
                           align="center"/>
        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import moment from "moment";
import {ROLE_TYPE} from "@/utils/Constant";
import { PaymentType } from '@/constants/paymentTypes';

export default {
  computed: {
    PaymentType() {
      return PaymentType
    },
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/agentSettlement/agent-statistics",
      merchantList: [],
      agentList: [],
      loading: false,
      exporting: false,
      country: this.$store.state.isPK ? 'PK' : 'BD',
      form: {
        appId: "",
        agentId: "",
        startDate: moment().subtract(3, 'days').format('yyyyMMDD'),
        endDate: moment().format('yyyyMMDD'),
        tradeOrderId: "",
      },
      timeDate: [],
    };
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      let start = moment().subtract(7, 'days').format('yyyyMMDD');
      let end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },
    exportDetail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/agentSettlement/agent-statistics/export", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.agentStatisticsExport'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res.text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
            this.exporting = false;
          }).catch((error) => {
        console.log(error);
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
        this.exporting = false;
      });
      this.loading = false;
    },
  },
  created() {
    this.$axios
        .get('/agent/selectAgentForOption', {params: {}})
        .then(res => {
          this.agentList = res.data
        })

    this.$axios
        .get("/merchant/selectListForOption", {params: {}})
        .then((res) => {
          this.merchantList = res.data;
          if (this.merchantList.length === 1) {
            this.form.appId = this.merchantList[0].value;
            this.$bus.$emit("refresh");
          }
        });
  },
};
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-form-item {
  margin-bottom: 5px;
}
</style>